var React = require('react');

function UsericonInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.9997 0.333344C5.67517 0.333344 0.333008 5.67551 0.333008 12C0.333008 18.3245 5.67517 23.6667 11.9997 23.6667C18.3242 23.6667 23.6663 18.3245 23.6663 12C23.6663 5.67551 18.3242 0.333344 11.9997 0.333344ZM11.9997 6.16668C14.0145 6.16668 15.4997 7.65068 15.4997 9.66668C15.4997 11.6827 14.0145 13.1667 11.9997 13.1667C9.98601 13.1667 8.49967 11.6827 8.49967 9.66668C8.49967 7.65068 9.98601 6.16668 11.9997 6.16668ZM6.04267 17.5673C7.08917 16.0273 8.83451 15.0007 10.833 15.0007H13.1663C15.166 15.0007 16.9102 16.0273 17.9567 17.5673C16.4657 19.1633 14.3505 20.1667 11.9997 20.1667C9.64884 20.1667 7.53367 19.1633 6.04267 17.5673Z","fill":"#C2C2C2"}));
}

UsericonInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = UsericonInline;

UsericonInline.default = UsericonInline;
